<template>
    <div>
        <v-container class="achievement">
            <div class="image-p">
                <v-layout row wrap>
                  <v-flex x12 style="">
                  <div style="display:flex;align-items:center;">
                      <v-btn small icon dark @click="$router.go(-1)">
                        <v-icon style="color:#10aa85;">arrow_back</v-icon>
                      </v-btn>
                      <h2 class="fw400" style="color:#10aa85;">Capaian Kamu</h2>
                  </div>
                  </v-flex>
              </v-layout>
            </div>
            <div
              class="info-icon"
              @click="infoD = true"
            >
              <v-icon
                style="color:#10aa85;"
                large
              >info_outline</v-icon>
            </div>
        </v-container>
        <v-container style="padding: 10px 0px 10px 0px;">
          <v-tabs
            v-model="filtertab"
            grow
            show-arrows
            color="transparent"
            max="430px"
            :disabled="loading"
            slider-color="none"
          >
            <v-tab :href="'#' + item.type" v-for="(item, index) in listType" :key="index" @click="filter(item.type)">
                  <v-btn
                  style="text-transform:none !important; border:1px solid lightgray; margin-left: 5px; margin-right: 5px;"
                  depressed
                  :flat="filtertab !== item.type"
                  round
                  :dark="filtertab === item.type"
                  :light="filtertab !== item.type"
                  small
                  :color="filtertab === item.type ? '#00ADE2' :'#c5c5c5'"
                  >
                  {{ item.title }}
                  </v-btn>
              </v-tab>
          </v-tabs>
        </v-container>
        <div style="display:flex; margin-top: 10%; justify-content:center; align-items:center;" v-if="loading">
            <!-- <div class="loader" v-if="loading"> -->
            <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
            <!-- </div> -->
        </div>
        <div  v-if="listType.length != 0 && !loading && !error">
        <div v-if="filtertab === 'SBMPTN' && listInsightRanking">
          <v-container style="padding-top:0px;">
            <v-card style="margin-top: 5px;border-radius: 10px; padding: 0px 15px 10px 15px;">
              <leveling-component :data="listInsightRanking"></leveling-component>
            </v-card>
          </v-container>
        </div>
        <v-container style="padding-top:0px;">
          <v-layout row wrap>
            <v-flex xs12 style="margin-bottom: 10px;">
              <h3>
                Ringkasan
              </h3>
            </v-flex>
            <v-flex xs4  v-for="(item, index) in listInsight" :key="index + 'stat'" style="padding:4px;">
              <summary-component :data="item"></summary-component>
            </v-flex>
            <v-flex xs12 style="text-align:center;">
              <v-btn :disabled="!allowPassing" medium light color="#355EAB" id="seeDetail" flat @click="$router.push('/achievement/statistik?type='+ filtertab)">
                Lihat Statistik
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- <line-chart></line-chart> -->
        <!-- <div style="height:100px;">

        </div> -->
        <v-container>
          <v-layout row wrap>
            <h3>
              Insight
            </h3>
          </v-layout>
          <div v-if="insights.length > 0">
            <v-card style="border-radius:10px; margin-top:15px;" v-for="(item, index) in insights" :key="index">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn flat medium color="#355EAB" id="btnTitle">
                    {{ item.title}}
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <radar-chart :datachart="item"></radar-chart>
                </v-flex>
                <v-flex xs12 style="text-align:center; background-color:#F9F9F9;">
                  <v-btn id="seeDetail" flat medium color="#355EAB" @click="$router.push('/achievement/insight/1?type=' + filtertab + '&category=' + item.category + '&title=' + item.title )">
                    Lihat Detail Grafik
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <div v-if="insights.length == 0 && !loading">
            <v-layout row wrap style="text-align:center; padding-top: 10px; padding-bottom:10px;">
              <v-flex xs12>
                <img src="@/assets/icon/achievement/img_emptyfilter.png" alt="image-alt"/>
              </v-flex>
              <v-flex xs12>
                Kamu belum mengerjakan Tryout atau Ujian, jadi belum ada informasi yang ditampilkan
              </v-flex>
              <v-flex xs12>
                <v-btn id="seeDetail" medium color="#10aa85" dark round @click="$router.push('/tryout-group')">
                  Yuk Kerjakan Tryout
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-container>
        </div>
        <v-dialog fullscreen v-model="infoD">
          <info-dialog @close="infoD = false" :list="listInsight"></info-dialog>
        </v-dialog>
        <div v-if="error" style="padding: 15px; margin-top: 15%;">
            <v-layout row wrap >
                <v-flex xs12 style="text-align:center;">
                <img src="@/assets/icon/achievement/img_errorsystem.png" alt="image-alt"/>
                <p style="color:#8E9196;">
                    Duh, kamu belum bisa lihat Capaian Kamu nih, karena sedang ada kesalahan di sistem kami. Kami akan infokan kalo sudah bisa diakses ya!
                </p>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<style>
.info-icon {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-end;
  float: right;
  cursor: pointer;
}
  .achievement {
    margin-bottom: 0px;
    display: flex;
    color:#10aa85;
    align-items: flex-start;
    background-color: white;
    background-size: 100%;
    padding: 1em;
    justify-content: space-between;
    box-shadow: 2px 0px 4px 0px lightgray;
  }

  #seeDetail .v-btn__content{
    text-transform: capitalize !important;
  }

.tab-tg.v-btn.v-btn--depressed.v-btn--round.theme--light {
  border: 1px solid #979797 !important;
}

.v-tabs__item{
  padding-left:0px !important;
  padding-right:0px !important;
}

#btnTitle {
  text-transform: capitalize;
}
/* .tab-tg.v-btn{
  margin-left:0px !important;
  margin-right:0px !important;
} */
</style>
<script>
import LineChart from '@/components/Achievement/LineChart'
import RadarChart from '@/components/Achievement/RadarChart'
import InfoDialog from '@/components/Achievement/InfoDialog'
import Summary from '@/components/Achievement/SummaryComp'
import Leveling from '@/components/Achievement/LevelingComp'
export default {
  name: 'capaian-kamu',
  data () {
    return {
      infoD: false,
      filtertab: 'SBMPTN',
      listType: [],
      listInsight: [],
      listInsightRanking: null,
      insights: [],
      allowPassing: false,
      loading: false,
      error: false

    }
  },
  components: {
    'line-chart': LineChart,
    'radar-chart': RadarChart,
    'info-dialog': InfoDialog,
    'summary-component': Summary,
    'leveling-component': Leveling
  },
  mounted () {
    this.getDataTryoutType()
  },
  methods: {
    getDataTryoutType () {
      this.loading = true
      this.$store.dispatch('funcGetTryoutType').then((response) => {
        this.listType = response.data.types
        if (!this.$route.query.type) {
          this.filtertab = response.data.types[0].type
        } else {
          this.filtertab = this.$route.query.type
        }
        this.getDataInsight()
      }).catch(err => {
        if (err.message == 'Request failed with status code 304') {
          let UID = sessionStorage.getItem('UID')
          let lcst = JSON.parse(localStorage.getItem('achievement-' + UID))
          this.listType = lcst.type.types
          if (!this.$route.query.type) {
            this.filtertab = response.data.types[0].type
          } else {
            this.filtertab = this.$route.query.type
          }
          this.getDataInsight()
        } else if (err.message == 'Request failed with status code 403') {
          // location.reload()
        } else {
          this.error = true
        }
        this.loading = false
        if (err) {}
      })
    },
    getDataInsight () {
      this.loading = true
      this.$store.dispatch('funcGetSummaryInsight', this.filtertab).then((response) => {
        this.loadDataInsight(response)
        this.loading = false
      }).catch((err) => {
        this.loading = false
        if (err.message == 'Request failed with status code 304') {
          let UID = sessionStorage.getItem('UID')
          let lcst = JSON.parse(localStorage.getItem('achievement-' + UID))
          let dd = lcst.summary_insight[this.filtertab]
          let ss = { data: dd }
          this.loadDataInsight(ss)
        } else {
          this.error = true
        }
        if (err) {}
      })
    },

    loadDataInsight (response) {
      this.allowPassing = false
      this.listInsightRanking = response.data.ranking
      this.listInsight = response.data.summary
      this.insights = response.data.insights
      this.listInsight.every(element => {
        if (element.value !== '0' && element.value !== '0%') {
          this.allowPassing = true
          return false
        }
      })
    },
    filter (type) {
      this.filtertab = type
      this.$router.replace({ 'query': { 'type': type } })
      this.getDataInsight()
    }
  }
  // watch: {
  //   filtertab(to, from) {
  //     this.getDataInsight()
  //   }
  // },
}
</script>
